import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { useContext } from "react";
import { BpContext } from "../context/AppContext";
import LocalDataService from "../services/localdata.service";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
function Dashboard() {
  return (
    <Container>
      <div className="d-flex justify-content-center">
        <h1>Dashboard</h1>
      </div>
    </Container>
  );
}

export default Dashboard;
